var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccFinancial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7885",
    "data-name": "Rectangle 7885",
    width: 28,
    height: 28,
    transform: "translate(444 1173)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7888",
    "data-name": "Rectangle 7888",
    width: 25.068,
    height: 21.487,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Financial_institutions",
    "data-name": "Financial institutions",
    transform: "translate(-444 -1173)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32417",
    "data-name": "Group 32417",
    transform: "translate(445.466 1176.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32416",
    "data-name": "Group 32416",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34655",
    "data-name": "Path 34655",
    d: "M9.767,9.848H0V6.7a2.47,2.47,0,0,1,2.47-2.47H6.918V2.849A2.883,2.883,0,0,1,9.767,0h5.371a3.188,3.188,0,0,1,3.092,3.011V4.234H22.6a2.47,2.47,0,0,1,2.47,2.47V9.85H15.3a2.767,2.767,0,1,1-5.534,0Zm5.779-5.613V3.011A.558.558,0,0,0,15,2.441H10.172a.556.556,0,0,0-.569.544V4.234Z",
    transform: "translate(0 0)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34656",
    "data-name": "Path 34656",
    d: "M18.881,11.706h-2.52a3.7,3.7,0,0,1-3.825,2.767,3.7,3.7,0,0,1-3.829-2.767H.08v9.685H25.066V11.706Z",
    transform: "translate(0.001 0.096)",
    fill: "#b3b6c6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccFinancial);
export default __webpack_public_path__ + "static/media/mcc_financial.63f5f5cd1100e515cdff3b8315f3f8d0.svg";
export { ForwardRef as ReactComponent };